import { render, staticRenderFns } from "./OrganisationAdminInputs.vue?vue&type=template&id=e7a06ca2&"
import script from "./OrganisationAdminInputs.vue?vue&type=script&lang=ts&"
export * from "./OrganisationAdminInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports